import { useEffect, useState } from 'react';
import { focusManager } from '@tanstack/react-query';

export default function useIsFocused() {
  const [focused, setFocused] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => setFocused(focusManager.isFocused()), 400);

    return () => clearInterval(interval);
  }, []);

  return focused;
}
